<app-ad-header [data]="data"></app-ad-header>
